module.exports = __webpack_public_path__ + "img/Categories_bg_06.fbb38ce2.jpg";